import React, { useState } from 'react'
import './SearchTiles.css';
import FrontCarImage from './Assets/FrontCarImage.png';
import StudentsImage from './Assets/StudentsImage.png';
import SideCarImg from './Assets/SideCarImg.png';
import BulbIcon from './Assets/BulbIcon.png'
const SearchTiles = ({setActiveSection, activeSection}) => {
  const [TilesInfo] = useState([
    {id: 1, section: "vehicle", ImageLink: SideCarImg, Heading: "Search by Vehicle", Text1: "Find the right course tailored to your vehicle type.", Text: "Click here to Explore a list of vehicle categories and choose the one that suits your needs.", href: '#VehicleTypes' },
    {id: 2, section: "license", ImageLink: FrontCarImage, Heading: "Search by License", Text1: "Looking for a specific license class?", Text: "Click here to browse license options and select the best course for your goals.", href: "#LicenseTypes" },
    {id: 3, section: "courses", ImageLink: StudentsImage, Heading: "Search All Courses", Text1: "Looking for the right course or license class?", Text: "Click here to quickly find courses using specific keywords.", href: "#CourseSearch" }

  ])
  // [rgba(238,238,238,1)]

  const handleSection =(section)=> {
   sessionStorage.removeItem("searchTiles");
    sessionStorage.setItem("searchTiles", section);
    setActiveSection(section);
  }


  return (


    <div className='relative flex flex-col justify-center items-center w-full flex-wrap gap-5 bg-[#4d4d4d00] mb-3 sm:mb-10  md:top-0 md:flex-row md:gap-10 2xl:gap-20'>


      {TilesInfo.map((value, index) =>

        <a  href={value.href} key={value.id} className={`${activeSection === value.section ? "bg-[#ABACEF]" : ""} border-solid border-2 border-[rgba(238,238,238,1)] bg-white max-w-[350px]  max-h-[355px] text-black no-underline
        flex justify-center  items-center flex-col gap-5
        transition-all rounded-2xl cursor-pointer 
        hover:scale-100 hover:origin-top-left hover:bg-[#ABACEF] md:hover:scale-[1.09] 
        TilesShadow`}
        onClick={()=> handleSection(value.section)}
        >
          <div className='w-20 md:w-28'>
            <img loading='lazy' src={value.ImageLink} alt="" className='w-full' />
          </div>
          <div className='flex flex-col gap-[5px]'>
            <h3 className='text-center Blackfont'>{value.Heading}</h3>
            <p className='w-56 md:w-72 text-center Regularfont '>{value.Text1}</p>
            <p className='w-56 md:w-72 text-center Regularfont '>{value.Text}</p>
          </div>
        </a>

      )}
      <picture>
        {/* <source media="(max-width:640px )" srcset="" /> */}
        <img loading='lazy' className='hidden xl:inline-block absolute -z-10 -left-32 -top-48 h-[380px]' src={BulbIcon} alt="" />
      </picture>

    </div>


  )
}

export default SearchTiles